import { render } from "./MailAddressChangePage.vue?vue&type=template&id=3654adf0"
import script from "./MailAddressChangePage.vue?vue&type=script&lang=ts"
export * from "./MailAddressChangePage.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3654adf0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3654adf0', script)) {
    api.reload('3654adf0', script)
  }
  
  module.hot.accept("./MailAddressChangePage.vue?vue&type=template&id=3654adf0", () => {
    api.rerender('3654adf0', render)
  })

}

script.__file = "src/views/mailAddressChange/MailAddressChangePage.vue"

export default script